/**
 * Default response message
 */
const responseMessage = {
    unknownError: () => {
        return {
            status: "error",
            message: "An unknown error!"
        };
    },
    error: (message = "Error! An error occurred. Please try again later or contact admin!") => {
        return {
            status: "error",
            message: message
        };
    },
    success: (data = [], message = "Successfully!") => {
        return {
            status: "success",
            message: message,
            data
        };
    }
};
export default {
    responseMessage: responseMessage
};